"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LockedSelectFeatures = _interopRequireDefault(require("ui-addon-upgrades/_core/lockedFeature/LockedSelectFeatures"));

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var _connectUpgradeData = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData"));

var LOCKED_FEATURE = _sources.sourceKeys.LOCKED_FEATURE;

var _default = (0, _connectUpgradeData.default)(_LockedSelectFeatures.default, LOCKED_FEATURE);

exports.default = _default;
module.exports = exports.default;